import React, { useEffect, useState } from "react";
import logoSuperBidSoldImg from "../../../assets/img/logo_sold_new.png";
import logoSuperBidImg from "../../../assets/img/LogoSBExchange.svg";

import styles from "./logo.module.scss"
interface LogoProps {
  children?: any;
  url?: string;
  onClick?: () => void;
  className?: any;
}

export const TEST_ID = 'logo-testid';

export const Logo: React.FC<LogoProps> = ({ children, url, onClick }) => {
  return url?.includes("sold") ? (
    <img 
      data-testid={TEST_ID}
      src={logoSuperBidSoldImg}
      alt="Logo Sold"
      width="180"
      height="55"
      onClick={onClick}
      className={styles.logo__img}
    />
  ) : (
    <img 
      data-testid={TEST_ID}
      src={logoSuperBidImg}
      alt="Logo Superbid"
      width="190"
      height="65"
      onClick={onClick}
      className={styles.logo__img}
    />
  );
};
